var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import striptags from 'striptags';
import i18n from 'components/translation/i18n';
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { FormDate } from 'components/form/FormDate';
import { FormInput } from 'components/form/FormInput';
import { Icon } from 'components/Icon';
import { Image } from 'components/Image';
import { Money } from 'components/Money';
import { DealItemDiscountedPrice } from './DealItemDiscountedPrice';
import { DealItemMobileCard, getDealItemMobileFieldRows } from './DealItemMobileCard';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { calculatePriceCurrency, getMarkup, getMargin, getPricePerUnitFromMarkup, getPricePerUnitFromMargin } from 'helpers/Pricing';
import { getDealItemName } from 'helpers/Deal';
import { getDealItemBundledExtensionParts } from 'helpers/quoteBundled';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { getDealItemDateLabel, shouldShowDealItemDateColumn } from 'helpers/formatPlannedDateLabel';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { DealModalDeleteConfirmation } from '../../modal/DealModalDeleteConfirmation';
import { DealItemPricingTableHeader } from './DealItemPricingTableHeader';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useUser } from 'components/user/UserProvider';
import { DealItemEditModal } from '../../modal/DealItemEditModal';
import { useModal } from 'components/modal/ModalStack';
import { formatFieldValue } from 'helpers/Field';
import { Confirm } from 'components/confirm/Confirm';
import { Button } from 'components/Button';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import classNames from 'classnames';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { QuoteMedia } from 'modules/public/quote/components/QuoteMedia';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import '../DealItemPanelGroupContent.scss';
import { getUnitOfMeasurementLabel } from 'modules/catalog/saleItem/forms/SaleItemForm';
import { useMemo } from 'react';
import { useAccount } from 'components/account/AccountProvider';
export function Item(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { editable, className, discountRep, hideSKU, item, onChangeProposedItem, pricingDisplay, hideTableHeader, onQuoteRemove } = props;
    const _r = useDealConfiguratorContext(), { onItemPriceChange, pricingParametersDisplay, deal, onItemQuantityChange, onItemDateChange, quantityType, updateDealItemFieldValues, updateMarkupPerItem } = _r, dealConfiguratorContext = __rest(_r, ["onItemPriceChange", "pricingParametersDisplay", "deal", "onItemQuantityChange", "onItemDateChange", "quantityType", "updateDealItemFieldValues", "updateMarkupPerItem"]);
    const quoteContext = useQuoteContext();
    const dealDetailContext = useDealDetailContext();
    const quoteDealItemFields = quoteContext.dealItemFields.length > 0
        ? quoteContext.dealItemFields
        : dealDetailContext.dealItemFields.length > 0
            ? dealDetailContext.dealItemFields
            : dealConfiguratorContext.dealItemFields;
    const configurationFields = quoteContext.configurationFields &&
        quoteContext.configurationFields.length > 0
        ? quoteContext.configurationFields
        : dealConfiguratorContext.configurationFields;
    const plannedDateMode = getConfigurationFieldValue(configurationFields, 'PLANNED_DATE_MODE') ||
        'DATE';
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const dealValue = deal !== null && deal !== void 0 ? deal : quoteContext.deal;
    const showLineDiscount = !editable && !!(dealValue === null || dealValue === void 0 ? void 0 : dealValue.showDiscount) && pricingDisplay !== 'BUNDLED';
    const showDateColumn = shouldShowDealItemDateColumn({
        plannedDateMode,
        editable,
        itemDate: item.date,
        plannedDateStart: dealValue === null || dealValue === void 0 ? void 0 : dealValue.plannedDateStart
    });
    const itemDateLabel = getDealItemDateLabel(item.date, dealValue === null || dealValue === void 0 ? void 0 : dealValue.plannedDateStart, dealValue === null || dealValue === void 0 ? void 0 : dealValue.plannedDateEnd);
    const bundledParts = useMemo(() => getDealItemBundledExtensionParts(item, dealValue), [dealValue, item]);
    const showBundledItemPricing = !editable && pricingDisplay === 'BUNDLED';
    const user = useUser();
    const modal = useModal();
    const breakpoint = useBreakpoint();
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [openModalEditFields, setOpenModalEditFields] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const dateCellRef = useRef(null);
    const [costPrice, setCostPrice] = useState(calculatePriceCurrency(item.variant && item.variant.price
        ? item.variant.price
        : ((_a = item.item.price) !== null && _a !== void 0 ? _a : 0), deal === null || deal === void 0 ? void 0 : deal.currency));
    const [amount, setAmount] = useState(item.price);
    const dealerDiscount = (discountRep * costPrice) / 100;
    const dealerPrice = costPrice - dealerDiscount;
    const [markup, setMarkup] = useState(getMarkup(dealerPrice, amount).toFixed(0).toString());
    const [margin, setMargin] = useState(getMargin(dealerPrice, amount).toFixed(0).toString());
    const [discount, setDiscount] = useState(dealerPrice !== 0
        ? Number((((dealerPrice - amount) / dealerPrice) * 100).toFixed(2))
        : 0);
    const [pricePerUnit, setPricePerUnit] = useState(Number.isFinite(amount) ? amount.toFixed(2).toString() : '0');
    const [userInputMarkup, setUserInputMarkup] = useState(false);
    const [userInputMargin, setUserInputMargin] = useState(false);
    const [userInputDiscount, setUserInputDiscount] = useState(false);
    const [userInputPricePerUnit, setUserInputPricePerUnit] = useState(true);
    const [quantityChange, setQuantityChange] = useState(false);
    const [tempQuantity, setTempQuantity] = useState(null);
    const [markupChange, setMarkupChange] = useState(false);
    const [discountChange, setDiscountChange] = useState(false);
    const markupRef = useRef(null);
    const marginRef = useRef(null);
    const discountRef = useRef(null);
    const pricePerUnitRef = useRef(null);
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    useEffect(() => {
        var _a;
        setCostPrice(calculatePriceCurrency(item.variant && item.variant.price
            ? item.variant.price
            : ((_a = item.item.price) !== null && _a !== void 0 ? _a : 0), deal === null || deal === void 0 ? void 0 : deal.currency));
    }, [deal === null || deal === void 0 ? void 0 : deal.currency, item.variant, item.item]);
    useEffect(() => {
        const salePrice = item.price;
        setPricePerUnit(Number.isFinite(salePrice) ? salePrice.toFixed(2) : '0');
        setMarkup(getMarkup(dealerPrice, salePrice).toFixed(0).toString());
        setMargin(getMargin(dealerPrice, salePrice).toFixed(0).toString());
        setDiscount(dealerPrice !== 0
            ? Number((((dealerPrice - salePrice) / dealerPrice) * 100).toFixed(2))
            : 0);
        // Reset temp quantity only when item.quantity changes from outside AND
        // we're not in the middle of a user edit (quantityChange is false)
        if (!quantityChange &&
            tempQuantity !== null &&
            tempQuantity === item.quantity) {
            setTempQuantity(null);
        }
    }, [item, quantityChange, tempQuantity, dealerPrice]);
    useEffect(() => {
        if (showDatePicker && dateCellRef.current) {
            const icon = dateCellRef.current.querySelector('.form-date-picto');
            icon === null || icon === void 0 ? void 0 : icon.click();
        }
    }, [showDatePicker]);
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChange = (value) => {
        const numericValue = Number(value);
        // Always track what user is typing to allow changing back to previous values
        // (e.g., changing from 2 back to 1)
        setQuantityChange(true);
        setTempQuantity(numericValue);
    };
    /**
     * @function onQuantityChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onQuantityChangeOnBlur = () => {
        if (!quantityChange || tempQuantity === null) {
            return;
        }
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute(applyToAll) {
            if (tempQuantity === null) {
                return;
            }
            // Always apply the change, even if tempQuantity equals item.quantity
            // This allows user to change back to a previous value
            const onQuantityChangeHandler = deal
                ? onItemQuantityChange
                : quoteContext.onItemQuantityChange;
            onQuantityChangeHandler(item, tempQuantity, applyToAll);
            setQuantityChange(false);
            setTempQuantity(null);
        }
        if (quantityType === 'GLOBAL') {
            execute(false);
            return;
        }
        if (dealValue === null || dealValue === void 0 ? void 0 : dealValue.directSale) {
            execute(true);
            return;
        }
        modal.present({
            style: 'dialog',
            title: t('Update quantity'),
            picto: 'edit',
            modal: (React.createElement(Confirm, { title: `${t('Would you like to synchronize this quantity with related packages and options?')}`, infos: t('Selecting "Yes" will align the quantities of all packages and options with the new product quantity. Selecting "No" will leave the current quantities unchanged.'), acceptText: t('Yes'), refuseText: t('No'), onAccept: () => {
                    execute(true);
                }, onRefuse: () => {
                    execute(false);
                } }))
        });
    };
    /**
     * @function onMarkupChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChangeOnBlur = () => {
        if (!markupChange) {
            return;
        }
        /**
         * @function execute
         * @hidden
         * @since 1.0.0
         */
        function execute(applyToAll) {
            updateMarkupPerItem(item.id, Number(markup), applyToAll);
            setMarkupChange(false);
        }
        if (quantityType === 'GLOBAL') {
            execute(false);
            return;
        }
        modal.present({
            style: 'dialog',
            title: t('Update markup'),
            picto: 'edit',
            modal: (React.createElement(Confirm, { title: `${t('Would you like to synchronize this markup with related packages and options?')}`, infos: t('Selecting "Yes" will align the quantities of all packages and options with the new product markup. Selecting "No" will leave the current markups unchanged.'), acceptText: t('Yes'), refuseText: t('No'), onAccept: () => {
                    execute(true);
                }, onRefuse: () => {
                    execute(false);
                } }))
        });
    };
    /**
     * @function onMarkupClick
     * @since 1.0.0
     * @hidden
     */
    const onMarkupClick = () => {
        var _a;
        setUserInputMarkup(true);
        setUserInputMargin(false);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = markupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarginClick
     * @since 1.0.0
     * @hidden
     */
    const onMarginClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(true);
        setUserInputDiscount(false);
        setUserInputPricePerUnit(false);
        (_a = marginRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDiscountClick
     * @since 1.0.0
     * @hidden
     */
    const onDiscountClick = () => {
        var _a;
        setUserInputMarkup(false);
        setUserInputMargin(false);
        setUserInputDiscount(true);
        setUserInputPricePerUnit(false);
        (_a = discountRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onProfitClick
     * @since 1.0.0
     * @hidden
     */
    const onProfitClick = () => {
        var _a;
        setUserInputPricePerUnit(true);
        setUserInputDiscount(false);
        setUserInputMarkup(false);
        setUserInputMargin(false);
        (_a = pricePerUnitRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onMarkupChange
     * @since 1.0.0
     * @hidden
     */
    const onMarkupChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMarkup(dealerPrice, Number(value));
        setMarkup(value);
        updateMarkupPerItem(item.id, Number(value), false);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onItemPriceChange &&
            onItemPriceChange(Object.assign(Object.assign({}, item), { price: pricePerUnit }), value, 'MARKUP');
        setMarkupChange(true);
    };
    /**
     * @function onMarginChange
     * @since 1.0.0
     * @hidden
     */
    const onMarginChange = (value) => {
        const pricePerUnit = getPricePerUnitFromMargin(dealerPrice, Number(value));
        setMargin(value);
        setPricePerUnit(pricePerUnit.toFixed(2));
        onItemPriceChange &&
            onItemPriceChange(Object.assign(Object.assign({}, item), { price: pricePerUnit }), value, 'MARGIN');
    };
    /**
     * @function onDiscountChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChange = (value) => {
        const pricePerUnit = dealerPrice - dealerPrice * (Number(value) / 100);
        setDiscount(Number(value));
        setPricePerUnit(pricePerUnit.toFixed(2));
        onItemPriceChange && onItemPriceChange(Object.assign(Object.assign({}, item), { price: pricePerUnit }));
        setDiscountChange(true);
    };
    /**
     * @function onDiscountChangeOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onDiscountChangeOnBlur = () => {
        var _a, _b, _c, _d;
        if (!discountChange) {
            return;
        }
        const hasOptionsOrPackages = ((_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 || ((_d = (_c = item.packages) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
        if (!hasOptionsOrPackages) {
            setDiscountChange(false);
            return;
        }
        function execute(applyToAll) {
            if (applyToAll) {
                const currentPrice = dealerPrice - dealerPrice * (discount / 100);
                onItemPriceChange &&
                    onItemPriceChange(Object.assign(Object.assign({}, item), { price: currentPrice }), discount.toString(), 'DISCOUNT');
            }
            setDiscountChange(false);
        }
        modal.present({
            style: 'dialog',
            title: t('Update discount'),
            picto: 'edit',
            modal: (React.createElement(Confirm, { title: `${t('Would you like to apply this discount to all related packages and options?')}`, infos: t('Selecting "Yes" will apply the same discount percentage to all packages and options. Selecting "No" will only change the discount for this item.'), acceptText: t('Yes'), refuseText: t('No'), onAccept: () => {
                    execute(true);
                }, onRefuse: () => {
                    execute(false);
                } }))
        });
    };
    /**
     * @function onPricePerUnitChange
     * @since 1.0.0
     * @hidden
     */
    const onPricePerUnitChange = (value) => {
        const markup = getMarkup(dealerPrice, Number(value)).toFixed(0);
        const margin = getMargin(dealerPrice, Number(value)).toFixed(0);
        const discount = ((dealerPrice - Number(value)) / dealerPrice) * 100;
        setPricePerUnit(value);
        //setMarkup(markup);
        setMargin(margin);
        setDiscount(Number(discount.toFixed(2)));
        updateMarkupPerItem(item.id, Number(markup), false);
    };
    /**
     * @function onItemPriceOnBlur
     * @since 1.0.0
     * @hidden
     */
    const onItemPriceOnBlur = () => {
        onItemPriceChange &&
            onItemPriceChange(Object.assign(Object.assign({}, item), { price: Number(pricePerUnit) }));
    };
    /**
     * @function onCloseModal
     * @since 1.0.0
     * @hidden
     */
    const onCloseModal = () => {
        if (openModalDelete) {
            setOpenModalDelete(false);
        }
        if (openModalEditFields) {
            setOpenModalEditFields(false);
        }
    };
    /**
     * @function onEditPress
     * @since 1.0.0
     * @hidden
     */
    function onEditPress() {
        setOpenModalEditFields(true);
    }
    /**
     * @function onManageItem
     * @since 1.0.0
     * @hidden
     */
    const onManageItem = (value) => {
        switch (value) {
            case 'delete':
                setOpenModalDelete(true);
                break;
            case 'proposed':
                if (onChangeProposedItem) {
                    onChangeProposedItem(item, true);
                }
                break;
            case 'notProposed':
                if (onChangeProposedItem) {
                    onChangeProposedItem(item, false);
                }
                break;
        }
    };
    /**
     * @function onSaleItemDetail
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetail() {
        var _a, _b;
        if (item === null || item === void 0 ? void 0 : item.item) {
            modal.present({
                title: hideSKU === 'FALSE' ? (_a = item === null || item === void 0 ? void 0 : item.item) === null || _a === void 0 ? void 0 : _a.sku : undefined,
                picto: '',
                className: 'deal-sale-item-selector-item-modal',
                modal: (React.createElement(SaleItemViewer, { item: item.item, variant: (_b = item.variant) !== null && _b !== void 0 ? _b : undefined }))
            });
        }
    }
    // Check if item have infos or image
    const hasInfos = !!((_b = item.item) === null || _b === void 0 ? void 0 : _b.infos);
    const hasSummary = !!((_c = item.item) === null || _c === void 0 ? void 0 : _c.summary) && !!striptags(item.item.summary).trim();
    const hasImage = !!((_d = item.item) === null || _d === void 0 ? void 0 : _d.image) && !!item.item.image.image.url;
    const isClickable = hasInfos || hasImage || hasSummary;
    const dropdown = [];
    if (item.proposed) {
        dropdown.push({
            value: 'notProposed',
            picto: 'plus',
            label: t('Include')
        });
    }
    else {
        dropdown.push({
            value: 'proposed',
            picto: 'heart',
            label: t('Suggest')
        });
    }
    dropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    const rowClassName = classNames({ 'deal-item-panel-group-content--isClickable': isClickable && !editable }, props.className);
    return editable || (!editable && breakpoint.isAboveOrEqual('md')) ? (React.createElement(React.Fragment, null,
        !hideTableHeader && (React.createElement(DealItemPricingTableHeader, { pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, className: className, editable: editable, hideSKU: hideSKU, isItem: true, showDateColumn: showDateColumn })),
        React.createElement("tr", { className: rowClassName },
            React.createElement("td", { className: "deal-item-panel-group-content-cell--primary", "data-label": t('Product') },
                React.createElement("div", { className: "deal-item-panel-group-content-cell--primary--title" },
                    !item.item.active || item.item.deletedAt ? (React.createElement(Icon, { value: "exclamation-triangle", style: "danger", tooltip: t('This item is no longer available.') })) : hasImage ? (React.createElement(Image, { className: "table-row-image", source: (_g = (_f = (_e = item.item) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.image.url) !== null && _g !== void 0 ? _g : '', onClick: onSaleItemDetail })) : hasInfos || hasSummary ? (React.createElement(Button, { style: "picto", picto: "circle-info", onPress: onSaleItemDetail })) : (React.createElement(Button, { style: "picto", picto: "", disabled: true })),
                    React.createElement(Text, { className: "deal-item-panel-group-content-value", value: getDealItemName(item, i18n.language, configurationFields) }))),
            hideSKU === 'FALSE' && (React.createElement("td", { "data-label": t('Sku'), className: "td-sku" },
                React.createElement(Text, { className: "deal-item-panel-group-content-value deal-item-panel-group-content-value--sku", value: (_j = (_h = item.variant) === null || _h === void 0 ? void 0 : _h.sku) !== null && _j !== void 0 ? _j : item.item.sku }))),
            React.createElement("td", null),
            showDateColumn && (React.createElement("td", { "data-label": t('Date'), className: "field-cell" }, editable ? (showDatePicker ? (React.createElement("div", { ref: dateCellRef },
                React.createElement(FormDate, { name: "date", value: item.date ? `${item.date}T00:00:00` : null, time: false, size: "small", portalId: "root", onChange: (value) => {
                        onItemDateChange(item, value ? value.substring(0, 10) : null);
                    }, onCalendarClose: () => setShowDatePicker(false) }))) : (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => setShowDatePicker(true) }, item.date ? (React.createElement(React.Fragment, null,
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: item.date }),
                React.createElement(Icon, { value: "pencil" }))) : (React.createElement(Button, { picto: "calendar", style: "picto" }))))) : itemDateLabel ? (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: itemDateLabel })) : null)),
            quoteDealItemFields.length
                ? quoteDealItemFields === null || quoteDealItemFields === void 0 ? void 0 : quoteDealItemFields.map((field) => {
                    var _a, _b;
                    const v = (_b = (_a = item.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => { var _a; return ((_a = fieldValue.field) === null || _a === void 0 ? void 0 : _a.id) === field.id; })) === null || _b === void 0 ? void 0 : _b.value;
                    return (React.createElement("td", { key: field.id, className: "field-cell" }, editable ? (React.createElement("div", { className: "field-cell--with-custom-field", onClick: () => onEditPress() }, v ? (field.type === 'FILE' ? (React.createElement(Icon, { value: "file" })) : (React.createElement(React.Fragment, null,
                        React.createElement(Text, { className: "deal-item-panel-group-content-value", value: formatFieldValue(v, field.type, field, i18n.language) }),
                        React.createElement(Icon, { value: "pencil" })))) : (React.createElement(Button, { picto: field.type === 'DATE'
                            ? 'calendar'
                            : field.type === 'TIME'
                                ? 'clock'
                                : 'plus', style: "picto" })))) : field.type === 'FILE' ? (React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(v, field.type, field), noLabel: true })) : (React.createElement(Text, { className: "deal-item-panel-group-content-value", value: v
                            ? formatFieldValue(v, field.type, field, i18n.language)
                            : '' }))));
                })
                : null,
            React.createElement("td", { "data-label": t('Quantity'), className: "deal-item-panel-group-content-value--qty" }, editable || (dealValue === null || dealValue === void 0 ? void 0 : dealValue.canEditQuantity) ? (React.createElement(FormInput, { className: "deal-item-panel-group-content-input input-quantity", type: "number", name: "quantity", value: item.quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: (dealValue === null || dealValue === void 0 ? void 0 : dealValue.directSale) ? '1' : '0', size: "small", suffix: getUnitOfMeasurementLabel(item.item.unitOfMeasurement) })) : (React.createElement("div", { className: "deal-item-panel-group-content-value--uneditable-qty" }, (item.quantity > 1 || Number(pricePerUnit) > 0) && (React.createElement(React.Fragment, null,
                React.createElement(Text, { className: "deal-item-panel-group-content-value", value: item.quantity.toString() }),
                React.createElement(Case, { is: getUnitOfMeasurementLabel(item.item.unitOfMeasurement) !==
                        '' },
                    React.createElement(Text, { className: "deal-item-panel-group-content-value--unitOfMeasurement", value: getUnitOfMeasurementLabel(item.item.unitOfMeasurement) }))))))),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Price'), className: "deal-item-panel-group-content-price" },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer Discount'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerDiscount })))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { "data-label": t('Dealer Price'), className: "deal-item-panel-group-content-price" },
                React.createElement(Case, { is: editable },
                    React.createElement(Money, { className: "deal-item-panel-group-content-value", value: dealerPrice })))),
            editable && pricingParameters === 'DISCOUNT' && (React.createElement("td", { "data-label": t('Discount') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onDiscountClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputDiscount ? onDiscountChange : undefined, onBlur: onDiscountChangeOnBlur, value: discount.toString(), disabled: userInputDiscount ? false : true, className: userInputDiscount ? 'number-input isActive' : 'number-input', ref: discountRef, size: "small" }),
                React.createElement(Icon, { value: userInputDiscount ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARKUP' &&
                (pricingParametersDisplay == 'line' ||
                    pricingParametersDisplay == 'item') && (React.createElement("td", { "data-label": t('Markup') + ' (%)', className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onMarkupClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMarkup ? onMarkupChange : undefined, onBlur: onMarkupChangeOnBlur, value: markup, disabled: userInputMarkup ? false : true, className: userInputMarkup ? 'number-input isActive' : 'number-input', ref: markupRef, size: "small" }),
                React.createElement(Icon, { value: userInputMarkup ? 'angle-left' : 'angle-right' }))),
            editable &&
                pricingParameters === 'MARGIN' &&
                (pricingParametersDisplay == 'line' ||
                    pricingParametersDisplay == 'item') && (React.createElement("td", { "data-label": t('Margin %'), className: "deal-item-panel-group-content-input input-markup-icon  input-markup-icon-content", onClick: onMarginClick },
                React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputMargin ? onMarginChange : undefined, 
                    //onBlur={onMarginChangeOnBlur}
                    value: margin, disabled: userInputMargin ? false : true, className: userInputMargin ? 'number-input isActive' : 'number-input', ref: marginRef, size: "small" }),
                React.createElement(Icon, { value: userInputMargin ? 'angle-left' : 'angle-right' }))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Selling Price') + ' ($', className: "deal-item-panel-group-content-input input-profit deal-item-panel-group-content-price", onClick: onProfitClick }, editable ? (React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputPricePerUnit ? onPricePerUnitChange : undefined, onBlur: onItemPriceOnBlur, value: pricePerUnit, disabled: userInputPricePerUnit ? false : true, className: userInputPricePerUnit
                    ? 'number-input isActive'
                    : 'number-input', ref: pricePerUnitRef, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        onItemPriceOnBlur();
                    }
                }, size: "small" })) : ((item.quantity > 1 ||
                Number(pricePerUnit) > 0 ||
                showBundledItemPricing) && (React.createElement(DealItemDiscountedPrice, { className: "deal-item-panel-group-content-value", value: showBundledItemPricing
                    ? ((_k = item.quantity) !== null && _k !== void 0 ? _k : 0) > 0
                        ? bundledParts.bundledExtension / ((_l = item.quantity) !== null && _l !== void 0 ? _l : 1)
                        : 0
                    : Number(pricePerUnit), listPrice: costPrice, showDiscount: showLineDiscount }))))),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'BUNDLED' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { "data-label": t('Amount'), className: "deal-item-panel-group-content-price" }, (item.quantity > 1 ||
                Number(pricePerUnit) > 0 ||
                showBundledItemPricing) && (React.createElement(Money, { className: "deal-item-panel-group-content-value", value: showBundledItemPricing
                    ? bundledParts.bundledExtension
                    : Number(pricePerUnit) * item.quantity })))),
            React.createElement(Case, { is: editable },
                React.createElement("td", { "data-label": t('Actions') },
                    React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManageItem }))),
            !editable && (React.createElement("td", { "data-label": t('Actions') }, onQuoteRemove && (React.createElement(Button, { label: t('Remove'), onPress: onQuoteRemove, style: "outline", picto: "trash-can" }))))),
        openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'item', item: item, onClose: onCloseModal, deleteConfirmationMessage: `${t('Delete')} ${getDealItemName(item, i18n.language, configurationFields)}?` })),
        openModalEditFields && (React.createElement(DealItemEditModal, { type: "item", item: item, customFields: quoteDealItemFields, onClose: onCloseModal, onUpdateItem: (updatedItem, applyToAll) => {
                if (updatedItem.fieldValues) {
                    updateDealItemFieldValues(updatedItem.id, updatedItem.fieldValues);
                }
                setOpenModalEditFields(false);
            } })))) : (React.createElement(DealItemMobileCard, { title: getDealItemName(item, i18n.language, configurationFields), meta: [hideSKU === 'FALSE' ? ((_o = (_m = item.variant) === null || _m === void 0 ? void 0 : _m.sku) !== null && _o !== void 0 ? _o : item.item.sku) : null], image: hasImage ? (_q = (_p = item.item) === null || _p === void 0 ? void 0 : _p.image) === null || _q === void 0 ? void 0 : _q.image.url : null, picto: hasInfos || hasSummary ? 'circle-info' : null, unavailable: !item.item.active || !!item.item.deletedAt, onPress: isClickable ? onSaleItemDetail : undefined, price: pricingDisplay === 'ALL' ||
            pricingDisplay === 'BUNDLED' ||
            pricingDisplay === 'LINE' ? (React.createElement(DealItemDiscountedPrice, { value: showBundledItemPricing
                ? bundledParts.bundledExtension
                : Number(pricePerUnit) * item.quantity, listPrice: costPrice * item.quantity, showDiscount: showLineDiscount })) : undefined, rows: [
            ...(showDateColumn && itemDateLabel
                ? [{ key: 'date', label: t('Date'), value: itemDateLabel }]
                : []),
            ...getDealItemMobileFieldRows(quoteDealItemFields, item.fieldValues),
            ...((dealValue === null || dealValue === void 0 ? void 0 : dealValue.canEditQuantity)
                ? [
                    {
                        key: 'quantity',
                        label: t('Quantity'),
                        interactive: true,
                        value: (React.createElement(FormInput, { className: "deal-item-mobile-card-quantity", type: "number", name: "quantity", value: item.quantity.toString(), onChange: (value) => onQuantityChange(value), onBlur: onQuantityChangeOnBlur, min: (dealValue === null || dealValue === void 0 ? void 0 : dealValue.directSale) ? '1' : '0', size: "small", suffix: getUnitOfMeasurementLabel(item.item.unitOfMeasurement) }))
                    }
                ]
                : item.quantity !== 1
                    ? [
                        {
                            key: 'quantity',
                            label: t('Quantity'),
                            value: `${item.quantity} ${getUnitOfMeasurementLabel(item.item.unitOfMeasurement)}`.trim()
                        }
                    ]
                    : [])
        ], actions: onQuoteRemove ? (React.createElement(Button, { label: t('Remove'), onPress: onQuoteRemove, style: "outline", picto: "trash-can" })) : undefined }));
}
